export default __webpack_public_path__ + "static/media/background-1.027600b7.svg";